//import
import './build/HeaderNavigation.js';
import './build/anchor.js';
import './build/slider.js';
import observerShowObj from './build/observerShowObj';
import './build/contactControl.js';

// menu toggle
window.addEventListener('load', () => {
  var trigger = document.querySelectorAll('.l-gnav__list__item-inner-btn');
  trigger.forEach(function (target) {
    target.addEventListener('click', function () {
      target.classList.toggle('active');
      target.parentNode.classList.toggle('active');
      target.nextElementSibling.classList.toggle('active');
    });
  });
});

// [クラス作成] observerで表示するオブジェクト
const observerElem = document.getElementsByClassName('p-animation-observer');
const createObserveObj = () => {
  if (!observerElem.length) return;
  for (let i = 0; i < observerElem.length; i++) {
    new observerShowObj(observerElem[i]);
  }
}
document.addEventListener('DOMContentLoaded', createObserveObj, false);
